import { useTranslation } from 'react-i18next';
import { twJoin } from 'tailwind-merge';
import { Banner } from './type';

interface SidebarBannerProps {
  banner: Banner;
  onClick: () => void;
}

export const SidebarBanner = ({ banner, onClick }: SidebarBannerProps) => {
  const { t } = useTranslation();

  return (
    <div
      onClick={onClick}
      className={twJoin(
        'hover:grayscale rounded-[15px] bg-cover cursor-pointer bg-no-repeat min-h-[70px] px-5 max-w-[310px] w-full min-w-[210px] flex flex-row justify-start items-center',
        banner.backgroundImage
      )}>
      <img src={banner.icon} alt={banner.title} className="w-[45px] h-auto mr-[20px]" />
      <div className="flex flex-col">
        <p className="text-gb_title text-[16px] font-bold first-letter:uppercase">
          {t(`${banner.title}`)}
        </p>
        <p className="text-gb_text text-[12px] font-bold lowercase">{t(`${banner?.text}`)}</p>
      </div>
    </div>
  );
};
